(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldDatepicker2', fbFieldDatepicker2Directive);

    function fbFieldDatepicker2Directive($timeout, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element:'=',
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldDatepicker2',
            controller: fbFieldDatepicker2DirectiveCtrl,
            controllerAs: 'fieldCtrl',
            bindToController: true,
            require: 'ngModel',
            link: function(scope, elem, link, ngModelCtrl) {
                var dp_object = $(elem);
                dp_object.datepicker(scope.fieldCtrl.dateOptions);
                var block = true;

                function changeFunc(e) {
                    // if (block) return;
                    if (!e.target.value || e.target.value.length == 0) {
                        if (!block) {
                            scope.fieldCtrl.commitValue(e.target.value);
                            scope.fieldCtrl.onEventTrigger('onChange');
                        }
                        return;

                    }
                    var isValid = moment(e.target.value, scope.fieldCtrl.parse_format).isValid();
                    if (isValid) {
                        scope.fieldCtrl.commitValue(e.target.value);
                        scope.fieldCtrl.onEventTrigger('onChange');
                    } else {
                        scope.fieldCtrl.current_model = null;
                        dp_object.datepicker('update', '');
                    }
                }


                scope.fieldCtrl.clearModel = function() {
                    scope.fieldCtrl.current_model = null;
                    scope.fieldCtrl.commitValue(scope.fieldCtrl.current_model);
                    dp_object.datepicker('hide');
                }


                dp_object.on('change', changeFunc);
                //
                // dp_object.on('focusout', function(e) {
                //     dp_object.datepicker('update', e.target.value);
                // });

                scope.fieldCtrl.commitValue = function(value) {
                    ngModelCtrl.$setViewValue(value);
                }

                ngModelCtrl.$render = function() {
                    // var view_value = ngModelCtrl.$viewValue;
                    // if (!ngModelCtrl.$viewValue) {
                    //     view_value = '';
                    // }
                    // if (ngModelCtrl.$viewValue == 'Invalid date') {
                    //     scope.fieldCtrl.current_model = null;
                    // }
                    scope.fieldCtrl.current_model = ngModelCtrl.$viewValue;
                    dp_object.datepicker('setDate', scope.fieldCtrl.current_model);
                    block = false;
                };
                //
                ngModelCtrl.$formatters.push(function(modelValue) {
                    if (!modelValue) {
                        scope.fieldCtrl.commitValue('');
                        return '';
                    }
                    if (modelValue == 'Invalid date') {
                        scope.fieldCtrl.commitValue('');
                        return '';
                    }
                    var formatter_date = moment(modelValue, scope.fieldCtrl.save_format).format(scope.fieldCtrl.parse_format);
                    // block = false;
                    return formatter_date;
                    // return moment(modelValue, scope.fieldCtrl.save_format).format(scope.fieldCtrl.parse_format);
                });
                //
                ngModelCtrl.$parsers.push(function(viewValue) {
                    if (!viewValue) {
                        return null;
                    }
                    var parser_date = moment(viewValue, scope.fieldCtrl.parse_format);
                    return parser_date.format(scope.fieldCtrl.save_format); 
                //     if (!moment.isValid(parser_date.toDate())) {
                //         parser_date = '';
                //     }
                //     return parser_date;

                });
            }
        };
    }

    function fbFieldDatepicker2DirectiveCtrl(lodash, FormBuilderService, $scope) {
        var fieldCtrl = this;
        var formIdentifier = '';
        this.$onInit = function() {
            fieldCtrl.current_model = null;

            formIdentifier = $scope.$parent.vm.formIdentifier;
            fieldCtrl.is_read_only = $scope.$parent.vm.pageData.fbData.settings.view_only

            FormBuilderService.sync(formIdentifier, fieldCtrl);

            fieldCtrl.onEventTrigger = fieldCtrl.pageData.eventsService.onEventTrigger.bind(fieldCtrl);
            fieldCtrl.getModelOptions = fieldCtrl.pageData.eventsService.getModelOptions.bind(fieldCtrl);
            fieldCtrl.display_format = lodash.get(fieldCtrl.element, 'options.display_format', 'dd/mm/yyyy');
            fieldCtrl.parse_format = 'DD/mm/YYYY';
            fieldCtrl.save_format = lodash.get(fieldCtrl.element, 'options.save_format', 'YYYY-mm-DD');

            fieldCtrl.dateOptions = angular.merge({
                    format: fieldCtrl.display_format,
                    autoclose: true,
                    forceParse: false,
                    keepEmptyValues: true,
                },
                generateOptions()
            );

        }

        function generateOptions() {
            var option = {};
            if (lodash.has(fieldCtrl.element, 'options.max')) {
                var now = lodash.get(fieldCtrl.element, 'options.max.now');
                if (now) {
                    option.endDate = new Date();
                } else {
                    var maxObj = fieldCtrl.element.options.max;
                    option.endDate = new Date(maxObj.year, maxObj.month - 1, maxObj.day);
                }
            }

            if (lodash.has(fieldCtrl.element, 'options.min')) {
                var now = lodash.get(fieldCtrl.element, 'options.min.now');
                if (now) {
                    option.startDate = new Date();
                } else {
                    var minObj = fieldCtrl.element.options.min;
                    option.startDate = new Date(minObj.year, minObj.month - 1, minObj.day);
                }
            }

            if (lodash.has(fieldCtrl.element, 'options.locale')) {
                var locale = lodash.get(fieldCtrl.element, 'options.locale');
                option.language = locale;
            }

            return option;
        }

    }
})();